var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LocalStorageStrategy_instances, _LocalStorageStrategy_dbName, _LocalStorageStrategy_keyPrefix, _LocalStorageStrategy_getPrefixedKey, _LocalStorageStrategy_getKey;
import { StorageStrategyErrors } from '../StorageErrors';
import AbstractStorageStrategy from './AbstractStorageStrategy';
class LocalStorageStrategy extends AbstractStorageStrategy {
    constructor(dbName) {
        super();
        _LocalStorageStrategy_instances.add(this);
        _LocalStorageStrategy_dbName.set(this, void 0);
        _LocalStorageStrategy_keyPrefix.set(this, void 0);
        __classPrivateFieldSet(this, _LocalStorageStrategy_dbName, dbName, "f");
        __classPrivateFieldSet(this, _LocalStorageStrategy_keyPrefix, `${__classPrivateFieldGet(this, _LocalStorageStrategy_dbName, "f")}_`, "f");
    }
    initialize() {
        return Promise.resolve();
    }
    async getItem(key) {
        return new Promise((resolve) => {
            const prefixedKey = __classPrivateFieldGet(this, _LocalStorageStrategy_instances, "m", _LocalStorageStrategy_getPrefixedKey).call(this, key);
            const valueString = localStorage.getItem(prefixedKey);
            if (valueString === null || valueString === 'null') {
                resolve(null);
                return;
            }
            const value = JSON.parse(valueString);
            resolve(value);
        });
    }
    async setItem(key, value) {
        return new Promise((resolve, reject) => {
            try {
                const prefixedKey = __classPrivateFieldGet(this, _LocalStorageStrategy_instances, "m", _LocalStorageStrategy_getPrefixedKey).call(this, key);
                const valueString = JSON.stringify(value);
                if (localStorage.getItem(prefixedKey)) {
                    throw new Error(StorageStrategyErrors.KEY_EXISTS);
                }
                localStorage.setItem(prefixedKey, valueString);
                resolve(value);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    async updateItem(key, value) {
        return new Promise((resolve, reject) => {
            try {
                const prefixedKey = __classPrivateFieldGet(this, _LocalStorageStrategy_instances, "m", _LocalStorageStrategy_getPrefixedKey).call(this, key);
                const valueString = JSON.stringify(value);
                if (!localStorage.getItem(prefixedKey)) {
                    throw new Error(StorageStrategyErrors.KEY_NOT_EXISTS);
                }
                localStorage.setItem(prefixedKey, valueString);
                resolve(value);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    async removeItem(key) {
        const prefixedKey = __classPrivateFieldGet(this, _LocalStorageStrategy_instances, "m", _LocalStorageStrategy_getPrefixedKey).call(this, key);
        localStorage.removeItem(prefixedKey);
    }
    async clear() {
        const allKeys = await this.prefixedKeys();
        for (const key of allKeys) {
            localStorage.removeItem(key);
        }
    }
    async key(keyIndex) {
        const keys = await this.prefixedKeys();
        const key = keys[keyIndex] ?? null;
        if (key === null || !key.startsWith(__classPrivateFieldGet(this, _LocalStorageStrategy_keyPrefix, "f"))) {
            return null;
        }
        return __classPrivateFieldGet(this, _LocalStorageStrategy_instances, "m", _LocalStorageStrategy_getKey).call(this, key);
    }
    async prefixedKeys() {
        const keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key !== null && key.startsWith(__classPrivateFieldGet(this, _LocalStorageStrategy_keyPrefix, "f"))) {
                keys.push(key);
            }
        }
        return keys;
    }
    async keys() {
        const keys = await this.prefixedKeys();
        return keys.map((key) => __classPrivateFieldGet(this, _LocalStorageStrategy_instances, "m", _LocalStorageStrategy_getKey).call(this, key));
    }
}
_LocalStorageStrategy_dbName = new WeakMap(), _LocalStorageStrategy_keyPrefix = new WeakMap(), _LocalStorageStrategy_instances = new WeakSet(), _LocalStorageStrategy_getPrefixedKey = function _LocalStorageStrategy_getPrefixedKey(key) {
    return `${__classPrivateFieldGet(this, _LocalStorageStrategy_keyPrefix, "f")}${key}`;
}, _LocalStorageStrategy_getKey = function _LocalStorageStrategy_getKey(key) {
    return key.slice(__classPrivateFieldGet(this, _LocalStorageStrategy_keyPrefix, "f").length);
};
export default LocalStorageStrategy;
